import type { FrameInferenceResult } from "@/types/inference";

export type ExampleData = Array<{
    isVideo: boolean;
    filePath: string;
    resizedFilePath?: string | null;
    isSharable: boolean;
    authenticatedData?: { url: string; resizedUrl?: string };
}>;

export enum BuildInferenceType {
    SAM3 = "sam3",
    OWLV2 = "owlv2"
}

export type BuildMetadataInferenceTypes = Record<string, BuildInferenceType>;

export type BuildMetadata = { inferenceTypes: BuildMetadataInferenceTypes };

export type CreateRapidWorkflowProps = {
    workspaceId?: string;
    task: string | null;
    groundTruthData: FrameInferenceResult[];
    isSync?: boolean;
    exampleData: ExampleData;
    buildMetadata: BuildMetadata;
};
